jQuery(function ($) {

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            let el = entry.target;
            let imageUrl = $(el).data('panorama');

            // Ochrana pred dvojitou inicializáciou
            if ($(el).data('viewer-initialized')) return;

            // Poistka pre Safari: Ak element nemá výšku v CSS, WebGL zlyhá
            if ($(el).height() === 0) {
                $(el).css('min-height', '400px'); // Nastav aspoň základnú výšku
            }

            $(el).data('viewer-initialized', true);

            // Inicializácia Pannellum
            let viewer = pannellum.viewer(el, {
                type: 'equirectangular',
                panorama: imageUrl,
                autoLoad: true,
                showZoomCtrl: true,
                compass: false,
                mouseZoom: true, // Odporúčam nechať true aj pre Safari
                hfov: 110,
                autoRotate: 0 // Bonus: jemná rotácia pomôže vizuálne potvrdiť, že to ide
            });

            // 🔥 Robustný Safari fix
            if (isSafari) {
                // Skúsime resize hneď po načítaní scény
                viewer.on('load', function() {
                    setTimeout(() => {
                        window.dispatchEvent(new Event('resize'));
                        viewer.resize();
                        
                        // Vynútenie prekreslenia cez prehliadač
                        requestAnimationFrame(() => {
                            const canvas = el.querySelector('canvas');
                            if (canvas) {
                                canvas.style.display = 'none';
                                canvas.offsetHeight; // Force reflow
                                canvas.style.display = 'block';
                            }
                        });
                    }, 400);
                });
            }

            observer.unobserve(el);
        });
    }, { 
        threshold: 0.1, // Citlivejšie spustenie
        rootMargin: '50px' // Začne načítavať 50px predtým, než to používateľ uvidí
    });

    $('.panorama').each(function () {
        observer.observe(this);
    });

});